import React from 'react';
import {ActivityIndicator, StyleSheet, View} from 'react-native';
import {connect} from 'react-redux';
import {
  AUTHENTICATED_ROUTES,
  UN_AUTHENTICATED_ROUTES,
} from '../../navigation/constants';
import {checkJWT} from '../../redux/actions';

class AuthLoading extends React.Component {
  componentDidMount() {
    const {isAuthenticated, navigation} = this.props;

    if (isAuthenticated) {
      checkJWT()
        .then(() => {
          navigation.navigate(AUTHENTICATED_ROUTES.main.path);
        })
        .catch(() => {
          navigation.navigate(UN_AUTHENTICATED_ROUTES.welcomeScreen.path);
        });
    } else {
      navigation.navigate(UN_AUTHENTICATED_ROUTES.welcomeScreen.path);
    }
  }

  render() {
    return (
      <View style={styles.root}>
        <ActivityIndicator size="large" color="#f94c2a" />
      </View>
    );
  }
}
const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
  },
});
const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.accessToken,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AuthLoading);
